import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import CreateMetaSite from './CreateMetaSite';

/** List-level create overlays; URL suffix via administrationOverlayRewrite. */
const MetaSitesListOverlay: React.FC = () => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/create') {
    return <CreateMetaSite />;
  }

  return null;
};

export default MetaSitesListOverlay;
